import React, { useState, useEffect, useContext } from "react";
import MeasurementsTable from "./measurements-table";
import { useLocation } from "react-router-dom";
import MeasurementsInput from "../../measuring/measurements-input";
import { MeasurementsProvider } from "../contexts/measurements-provider";

import "../upcs/upcs.scss";
import { ViewOnlyPermissionsContext } from "contexts/view-only-permissions/view-only-permissions";
import { ShipmentContext } from "../contexts";

const Measurements = (props) => {
    const { viewOnlyShipment } = useContext(ViewOnlyPermissionsContext);
    const { shipmentData, upcTasks } = useContext(ShipmentContext);
    const [anchorTarget, setAnchorTarget] = useState(null);
    const [disableSave, setDisableSave] = useState(false);
    const { hash } = useLocation();

    useEffect(() => {
        if (hash) {
            setAnchorTarget(document.querySelector(hash));
        }
    }, [hash]);

    useEffect(() => {
        if (anchorTarget) {
            setTimeout(() => {
                anchorTarget.scrollIntoView({ top: document.body.scrollHeight, behavior: "smooth" });
            }, 1500);
        }
    }, [anchorTarget]);

    return (
        <MeasurementsProvider>
            <fieldset>
                <legend>Measurements For This Shipment</legend>
                <div
                    id="measurements"
                    className="row measurements-section"
                >
                    <div className="column -span5">
                        <div>
                            <MeasurementsTable
                                shipmentKey={props.shipmentKey}
                                disableNotes={viewOnlyShipment.createNote}
                                disableCompleteRedo={viewOnlyShipment.disableCompleteMeasurements}
                                setDisableSave={setDisableSave}
                            />
                        </div>
                    </div>

                    <div className="column -span7 measurements-input ">
                        <MeasurementsInput
                            shipmentKey={props.shipmentKey}
                            shipmentData={shipmentData}
                            disableSave={disableSave}
                            upcTasks={upcTasks}
                        />
                    </div>
                </div>
            </fieldset>
        </MeasurementsProvider>
    );
};

export default Measurements;
